import React from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';

type Props = React.PropsWithChildren;

export const Trigger: React.FC<Props> = (props) => {
  return <AlertDialog.Trigger asChild>{props.children}</AlertDialog.Trigger>;
};
